import React from 'react';
import './DeliveryLocations.css';

function DeliveryLocations() {
  const locations = [
    { id: 1, name: 'Houston', icon: '📍' },
    { id: 2, name: 'Sugar Land', icon: '📍' },
    { id: 3, name: 'Katy', icon: '📍' }
  ];

  return (
    <section className="delivery-locations">
      <div className="delivery-content">
        <h2 className="delivery-heading">Delivering To:</h2>
        <div className="locations-container">
          {locations.map(location => (
            <div key={location.id} className="location-badge">
              <span className="location-icon" aria-hidden="true">{location.icon}</span>
              <span className="location-name">{location.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DeliveryLocations;
